import { render, staticRenderFns } from "./DocumentKardex.vue?vue&type=template&id=5fb91f84"
import script from "./DocumentKardex.vue?vue&type=script&lang=js"
export * from "./DocumentKardex.vue?vue&type=script&lang=js"
import style0 from "./DocumentKardex.vue?vue&type=style&index=0&id=5fb91f84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports